import { useMemo } from 'react';
import {
  useCreateCommentMutation,
  useGetCommentsQuery,
} from './comment.api.slice';
import CommentThreadList from '@/components/Comment/CommentThreadList';
import DeletePostComment from './DeletePostComment';

function PostCommentList({ postId }: { postId: string }) {
  const { data: allComments, isLoading } = useGetCommentsQuery(postId);
  const [createComment] = useCreateCommentMutation();

  // Filter out admin comments - only show user comments
  const comments = useMemo(() => {
    return (
      allComments?.filter(
        (comment) => comment.commentType !== 'admin_comment'
      ) || []
    );
  }, [allComments]);

  return (
    <CommentThreadList
      comments={comments}
      isLoading={isLoading}
      renderDelete={(comment) => (
        <DeletePostComment
          commentId={comment._id}
          postId={postId}
          userId={comment.user?._id ?? ''}
        />
      )}
      onReply={async (parentCommentId, body) => {
        await createComment({
          postId,
          comment: body,
          parentCommentId,
        }).unwrap();
      }}
    />
  );
}

export default PostCommentList;
